// @flow
import { UneTypesActionTypes } from './constants';

const INIT_STATE = {
    loading: false,
    error: false,
    uneTypesList: [],
    uneTouristypesList: [],
    cuisineTypesList: [],
    clientTypesList: []
};

type UneTypesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { uneTypesList?: [] | null, uneTouristypesList?: [] | null, cuisineTypesList?: [] | null, clientTypesList?: [] | null, loading?: boolean, +value ?: boolean };

const UneTypes = (state: State = INIT_STATE, action: UneTypesAction): any => {
    // console.log(action);
    switch (action.type) {
        case UneTypesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case UneTypesActionTypes.LIST_UNE_TYPES: {
                    return {
                        ...state,
                        uneTypesList: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case UneTypesActionTypes.LIST_UNE_TOURIST_TYPES: {
                    return {
                        ...state,
                        uneTouristypesList: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case UneTypesActionTypes.LIST_CUISINE_TYPES: {
                    return {
                        ...state,
                        cuisineTypesList: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case UneTypesActionTypes.LIST_CLIENT_TYPES: {
                    return {
                        ...state,
                        clientTypesList: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }
        case UneTypesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case UneTypesActionTypes.LIST_UNE_TYPES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        uneTypesList: [],
                        loading: false,
                    };
                }
                case UneTypesActionTypes.LIST_UNE_TOURIST_TYPES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        uneTouristypesList: [],
                        loading: false,
                    };
                }
                case UneTypesActionTypes.LIST_CUISINE_TYPES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        cuisineTypesList: [],
                        loading: false,
                    };
                }
                case UneTypesActionTypes.LIST_CLIENT_TYPES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        clientTypesList: [],
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case UneTypesActionTypes.LIST_UNE_TYPES:
            return { ...state, error: false, loading: true };
        case UneTypesActionTypes.LIST_UNE_TOURIST_TYPES:
            return { ...state, error: false, loading: true };
        case UneTypesActionTypes.LIST_CUISINE_TYPES:
            return { ...state, error: false, loading: true };
        case UneTypesActionTypes.LIST_CLIENT_TYPES:
            return { ...state, error: false, loading: true };
        case UneTypesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                uneTypesList: [],
                uneTouristypesList: [],
                cuisineTypesList: [],
                clientTypesList: []
            }
        default:
            return { ...state };
    }
};

export default UneTypes;
